import { Component, Inject, OnInit  } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ParamMap } from '@angular/router';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from "@angular/forms";
import {SnackbarComponent} from '../../../components/alerts/snackbar/snackbar.component';
import {BoardService} from "../../../services/board/board.service";
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import {EndpointService} from "../../../services/endpoint/endpoint.service";
import { User, Owner} from '../../../modele/user/userModel';
import {ActivatedRoute} from '@angular/router';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-request-dialog',
  templateUrl: './request-dialog.component.html',
  styleUrls: ['./request-dialog.component.scss']
})
export class RequestDialogComponent implements OnInit {
    private lp:string=this.constructor.name;
    board_name:string="";
    user_name:string="";
    username;
    contactFormGroup: FormGroup;
    local_user_email: string = "yourEmail@yourprovider.com";
    local_user_name: string = "username";
    local_user_id: number = -1;
    local_user:User;
    isUserLoggedInn:boolean;

    constructor(
    private formBuilder: FormBuilder,
    private endpointSrv: EndpointService,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private boardService: BoardService,
    public dialogRef: MatDialogRef<RequestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData)
    {
        this.board_name = this.router.url.substr(1);
        this.endpointSrv.getloadisreadyEmitter().subscribe(ready=>{
            if(ready == true){
                this.endpointSrv.getUserLoginStateEmitter().subscribe(loginState=>{
                    this.isUserLoggedInn=loginState;
                })
            }
        })
    }
    ngOnInit() {
        setTimeout(()=>{
            this.username = this.data['username']
        },3000)
        this.contactFormGroup = this.formBuilder.group({
            message: ['', Validators.required],
            username: [this.data['username']] ,
            useremail: [this.data['email']]
        });
    }
    onNoClick(): void {
        this.dialogRef.close();
    }
    getAllData(){
    }
    submit() {
        this.dialogRef.close();
        this.endpointSrv.sendContactMessageToWhooosh(this.data['user_id'], this.data['email'], this.data['username'], "Bitte sendet mir meine Daten", "request Data").subscribe(data=>{
        });
        this.snackBar.openFromComponent(SnackbarComponent, {
            panelClass: "snackbar",
            duration: 1500,
            horizontalPosition: 'center',
            data: {
            message: 'keyword_$286',
            icon: 'analytics'
        }
        });
    }
    callingfunction(){
        setTimeout(() => {
            this.getAllData()
        }, 1000);
    }
}
